import { render } from "./orderResumen.vue?vue&type=template&id=0a539800&scoped=true&lang=html"
import script from "./orderResumen.vue?vue&type=script&lang=js"
export * from "./orderResumen.vue?vue&type=script&lang=js"

import "./orderResumen.vue?vue&type=style&index=0&id=0a539800&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a539800"]])

export default __exports__